import { useContext, useEffect, useRef, useState } from "react";
import Notas from "../../page/notas/Notas";
import { fetchNotas, notaState } from "../../models/notas";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { contextProvider } from "../../../context/ContextProvider";
import Alerts from "../../components/Alerts/Alerts";
import RestApi from "../../../helpers/RestApi";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";

const NotasController = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const context = useContext(contextProvider);
  const { FORMs, VALIDATIONs, URLs } = context;

  //const _notas = useSelector(notaState);
  //const notas = _notas.notas;

  const [notas, setNotas] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    per_page: 50,
    ["filter[stated]"]: "ACTIVO",
    sort: "-id",
  });
  const controllerRef = useRef(null);

  const { URL_NOTA_INDEX, URL_NOTA_UPDATE } = URLs;

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controllerRef.current) controllerRef.current.abort();

          controllerRef.current = new AbortController();
          const signal = controllerRef.current.signal;

          let params = {
            ...filter,
            ["filter[titulo]"]: e.target.value,
          };

          if (e.target.value.length == 0) {
            delete params["filter[titulo]"];
            setLoading(true);
            setFilter({ ...params });

            return fetch(setNotas, params, "/notas", signal, setLoading);
          }

          params = {
            ...params,
            ["filter[titulo]"]: e.target.value,
          };

          setLoading(true);
          setFilter({ ...params });

          return fetch(setNotas, params, "/notas", signal, setLoading);
        }
        break;
      default:
        break;
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "nuevo_evento":
        {
          return navigation("/dashboard/nota/crear");
        }
        break;
      case "vista_previa":
        {
        }
        break;
      case "editar":
        {
          return navigation("/dashboard/nota/" + value);
        }
        break;
      case "stated":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("id", value.id);
          formData.append("status", value.status);

          const response = await RestPrivateAntesala({
            url: `/notas/${value.id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.status == 201 || response.status == 200) {
            let params = {
              url: URL_NOTA_INDEX,
              //status: 1
            };
            dispatch(fetchNotas(params));

            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "401",
              type: "success",
            });
          } else {
            if (typeof response.data.msg === "string") {
              Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal, loading) => {
    try {
      const response = await apiPrivateAntesala.get(url, {
        params,
        signal,
      });
      if (response.status == 201 || response.status == 200) {
        setData(response.data);
        if (loading) {
          loading(false);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (!notas) {
      setLoading(true);
      let params = {
        ...filter,
      };

      fetch(setNotas, params, "/notas", null, setLoading);
    }
  }, []);

  /*
  useEffect(() => {
    if (!notas) {
      let params = {
        url: URL_NOTA_INDEX,
        //status: 1
      };
      dispatch(fetchNotas(params));
    }
  }, []);
  */

  console.log(notas);

  return (
    <>
      <Notas
        setFilter={setFilter}
        filter={filter}
        data={notas ?? { data: [] }}
        setData={setNotas}
        onClick={onClick}
        onChange={onChange}
        loading={loading}
        fetch={fetch}
      />
    </>
  );
};

export default NotasController;
